import { gql } from 'apollo-angular'

import { MAGAZINE_BASIC_FIELDS } from '../../fragments/magazine.fragments'

export const GET_MAGAZINE_BY_ARTICLE_ID = gql`
  query getMagazineByArticleId($articleId: Int!) {
    Article(id: $articleId, select: true) {
      magazine {
        ...MagazineBasicFields
      }
    }
  }
  ${MAGAZINE_BASIC_FIELDS}
`
